import { minLength, object, pipe, string, trim } from "valibot";

export const QuestionnaireCustomInputSchema = object({
  customInput: pipe(string(), trim(), minLength(1, "Text is required")),
});
